import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { StyledCTALink } from './ProductCTAStyles';
import { IProductCTALink } from '../../interfaces/IProductCTA';

export const ProductCTALink = translate(['ctaLinkLabel'])(
    observer(function ProductCTALink({ navigateToProduct, translations }: IProductCTALink) {
        const { ctaLinkLabel } = translations as ITranslationsCollection;

        return <StyledCTALink label={ctaLinkLabel} onCTALinkClick={navigateToProduct} />;
    })
);
